import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { brandingConfig } from './branding';

import commonEN from '@/locales/en/common.json';
import navigationEN from '@/locales/en/navigation.json';
import authEN from '@/locales/en/auth.json';
import paymentsEN from '@/locales/en/payments.json';
import disputesEN from '@/locales/en/disputes.json';
import ordersEN from '@/locales/en/orders.json';
import storesEN from '@/locales/en/stores.json';
import homeEN from '@/locales/en/home.json';
import profileEN from '@/locales/en/profile.json';
import processorsEN from '@/locales/en/processors.json';
import subscriptionsEN from '@/locales/en/subscriptions.json';
import customersEN from '@/locales/en/customers.json';
import productsEN from '@/locales/en/products.json';
import paymentFlowsEN from '@/locales/en/payment-flows.json';
import taxesEN from '@/locales/en/taxes.json';
import shippingsEN from '@/locales/en/shippings.json';
import languagesEN from '@/locales/en/languages.json';
import domainsEN from '@/locales/en/domains.json';
import upsellsEN from '@/locales/en/upsells.json';
import postPurchaseRulesEN from '@/locales/en/postPurchaseRules.json';
import settingsEN from '@/locales/en/settings.json';
import clubEN from '@/locales/en/club.json';
import searchEN from '@/locales/en/search.json';
import emailsEN from '@/locales/en/emails.json';
import externalRequestsEN from '@/locales/en/external-requests.json';
import integrationsEN from '@/locales/en/integrations.json';
import analyticsEN from '@/locales/en/analytics.json';
import storefrontEN from '@/locales/en/storefront.json';
import transactionsEN from '@/locales/en/transactions.json';
import onboardingEN from '@/locales/en/onboarding.json';
import referralEN from '@/locales/en/referral.json';
import partnerProvisioningEN from '@/locales/en/partnerProvisioning.json';
import partnerApiKeysEN from '@/locales/en/partnerApiKeys.json';
import partnerPayoutsEN from '@/locales/en/partnerPayouts.json';
import setupEN from '@/locales/en/setup.json';
import reportsEN from '@/locales/en/reports.json';
import billingEN from '@/locales/en/billing.json';
import manageApplePayEN from '@/locales/en/manage-apple-pay.json';
import manageCryptoPaymentsEN from '@/locales/en/manage-crypto-payments.json';
import rxEN from '@/locales/en/rx.json';
import notificationsEN from '@/locales/en/notifications.json';

import commonFR from '@/locales/fr/common.json';
import navigationFR from '@/locales/fr/navigation.json';
import authFR from '@/locales/fr/auth.json';
import paymentsFR from '@/locales/fr/payments.json';
import disputesFR from '@/locales/fr/disputes.json';
import ordersFR from '@/locales/fr/orders.json';
import storesFR from '@/locales/fr/stores.json';
import homeFR from '@/locales/fr/home.json';
import profileFR from '@/locales/fr/profile.json';
import processorsFR from '@/locales/fr/processors.json';
import subscriptionsFR from '@/locales/fr/subscriptions.json';
import customersFR from '@/locales/fr/customers.json';
import productsFR from '@/locales/fr/products.json';
import paymentFlowsFR from '@/locales/fr/payment-flows.json';
import taxesFR from '@/locales/fr/taxes.json';
import shippingsFR from '@/locales/fr/shippings.json';
import languagesFR from '@/locales/fr/languages.json';
import domainsFR from '@/locales/fr/domains.json';
import upsellsFR from '@/locales/fr/upsells.json';
import postPurchaseRulesFR from '@/locales/fr/postPurchaseRules.json';
import settingsFR from '@/locales/fr/settings.json';
import clubFR from '@/locales/fr/club.json';
import searchFR from '@/locales/fr/search.json';
import emailsFR from '@/locales/fr/emails.json';
import externalRequestsFR from '@/locales/fr/external-requests.json';
import integrationsFR from '@/locales/fr/integrations.json';
import analyticsFR from '@/locales/fr/analytics.json';
import storefrontFR from '@/locales/fr/storefront.json';
import transactionsFR from '@/locales/fr/transactions.json';
import onboardingFR from '@/locales/fr/onboarding.json';
import referralFR from '@/locales/fr/referral.json';
import partnerProvisioningFR from '@/locales/fr/partnerProvisioning.json';
import partnerApiKeysFR from '@/locales/fr/partnerApiKeys.json';
import partnerPayoutsFR from '@/locales/fr/partnerPayouts.json';
import setupFR from '@/locales/fr/setup.json';
import reportsFR from '@/locales/fr/reports.json';
import billingFR from '@/locales/fr/billing.json';
import manageApplePayFR from '@/locales/fr/manage-apple-pay.json';
import manageCryptoPaymentsFR from '@/locales/fr/manage-crypto-payments.json';
import rxFR from '@/locales/fr/rx.json';
import notificationsFR from '@/locales/fr/notifications.json';

const resources = {
  en: {
    common: commonEN,
    navigation: navigationEN,
    auth: authEN,
    payments: paymentsEN,
    disputes: disputesEN,
    orders: ordersEN,
    stores: storesEN,
    home: homeEN,
    profile: profileEN,
    processors: processorsEN,
    subscriptions: subscriptionsEN,
    customers: customersEN,
    products: productsEN,
    paymentFlows: paymentFlowsEN,
    taxes: taxesEN,
    shippings: shippingsEN,
    languages: languagesEN,
    domains: domainsEN,
    upsells: upsellsEN,
    postPurchaseRules: postPurchaseRulesEN,
    settings: settingsEN,
    club: clubEN,
    search: searchEN,
    emails: emailsEN,
    externalRequests: externalRequestsEN,
    integrations: integrationsEN,
    analytics: analyticsEN,
    storefront: storefrontEN,
    transactions: transactionsEN,
    onboarding: onboardingEN,
    referral: referralEN,
    partnerProvisioning: partnerProvisioningEN,
    partnerApiKeys: partnerApiKeysEN,
    partnerPayouts: partnerPayoutsEN,
    setup: setupEN,
    reports: reportsEN,
    billing: billingEN,
    manageApplePay: manageApplePayEN,
    manageCryptoPayments: manageCryptoPaymentsEN,
    rx: rxEN,
    notifications: notificationsEN,
  },
  fr: {
    common: commonFR,
    navigation: navigationFR,
    auth: authFR,
    payments: paymentsFR,
    disputes: disputesFR,
    orders: ordersFR,
    stores: storesFR,
    home: homeFR,
    profile: profileFR,
    processors: processorsFR,
    subscriptions: subscriptionsFR,
    customers: customersFR,
    products: productsFR,
    paymentFlows: paymentFlowsFR,
    taxes: taxesFR,
    shippings: shippingsFR,
    languages: languagesFR,
    domains: domainsFR,
    upsells: upsellsFR,
    postPurchaseRules: postPurchaseRulesFR,
    settings: settingsFR,
    club: clubFR,
    search: searchFR,
    emails: emailsFR,
    externalRequests: externalRequestsFR,
    integrations: integrationsFR,
    analytics: analyticsFR,
    storefront: storefrontFR,
    transactions: transactionsFR,
    onboarding: onboardingFR,
    referral: referralFR,
    partnerProvisioning: partnerProvisioningFR,
    partnerApiKeys: partnerApiKeysFR,
    partnerPayouts: partnerPayoutsFR,
    setup: setupFR,
    reports: reportsFR,
    billing: billingFR,
    manageApplePay: manageApplePayFR,
    manageCryptoPayments: manageCryptoPaymentsFR,
    rx: rxFR,
    notifications: notificationsFR,
  },
};

const initI18n = () => {
  i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common',
      'navigation',
      'auth',
      'payments',
      'disputes',
      'orders',
      'stores',
      'home',
      'profile',
      'processors',
      'subscriptions',
      'customers',
      'products',
      'paymentFlows',
      'taxes',
      'shippings',
      'languages',
      'domains',
      'upsells',
      'postPurchaseRules',
      'settings',
      'club',
      'search',
      'emails',
      'externalRequests',
      'integrations',
      'analytics',
      'storefront',
      'transactions',
      'onboarding',
      'referral',
      'partnerProvisioning',
      'partnerApiKeys',
      'partnerPayouts',
      'setup',
      'reports',
      'billing',
      'manageApplePay',
      'manageCryptoPayments',
      'rx',
      'notifications',
    ],
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        appName: brandingConfig.appName,
        hubName: brandingConfig.hubName ?? `${brandingConfig.appName} Hub`,
        rxName: 'Rx',
        platformName: 'TagadaPay',
      },
    },
    debug: false,
  });
};

export { initI18n };
export default i18n;
